module.exports = __webpack_public_path__ + "static/hut-audio-931d2c0e50b20cae21ecec0df788bb48.mp3";